import { render } from "./zulutrade-data.vue?vue&type=template&id=4d9c54c6"
import script from "./zulutrade-data.vue?vue&type=script&lang=js"
export * from "./zulutrade-data.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__